import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { connect, disconnect } from '../api/modules/realtimeMessaging';

// List of paths that require WebSocket connection
const WEBSOCKET_PATHS = ['/j/', '/jd/', '/jt/', '/p/', '/pt/', '/pd/', '/q/'];

export const useWebSocket = () => {
  const location = useLocation();
  const isConnected = useRef(false);
  const connectionTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const shouldConnect = WEBSOCKET_PATHS.some((path) => location.pathname.startsWith(path));

    if (shouldConnect && !isConnected.current) {
      // Clear any existing timeout
      if (connectionTimeout.current) {
        clearTimeout(connectionTimeout.current);
        connectionTimeout.current = null;
      }

      // Delay connection slightly to allow for route transition
      connectionTimeout.current = setTimeout(() => {
        console.log('[WebSocket] Connecting for path:', location.pathname);
        connect();
        isConnected.current = true;
      }, 100);
    } else if (!shouldConnect && isConnected.current) {
      console.log('[WebSocket] Disconnecting for path:', location.pathname);
      disconnect();
      isConnected.current = false;
    }

    return () => {
      if (connectionTimeout.current) {
        clearTimeout(connectionTimeout.current);
        connectionTimeout.current = null;
      }
      if (isConnected.current) {
        console.log('[WebSocket] Cleaning up connection');
        disconnect();
        isConnected.current = false;
      }
    };
  }, [location.pathname]);
};
